import { BsArrowRight } from "react-icons/bs";
import { CgClose } from "react-icons/cg";

function Modal({ isOpen, project, closeHandler }) {
  if (isOpen) {
    return (
      <div className="modal__container">
        <div className="modal__close" onClick={() => closeHandler()}>
          <CgClose />
        </div>
        <div className="modal__top--background">
          <div className="modal__top">
            <div className="modal__top--image">
              <img src={project.topImage} alt="" />
            </div>
          </div>

          <div className="modal__project--background">
            <div className="modal__project--wrapper">
              <div className="modal__title playfair">{project.title}</div>
              <div className="modal__type">{project.type}</div>
              <div className="modal__description">{project.description}</div>
              <div className="modal__view--button-wrapper ">
                <a
                  href={project.liveLink}
                  target="_blank"
                  className="modal__view-online--button playfair"
                >
                  View Online <BsArrowRight />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return <></>;
  }
}

export default Modal;
